import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'scriptInjection',
  initialState: null as null | string,
  reducers: {
    setScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setScriptInjection } = slice.actions;

export default slice.reducer;
